import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import React, { useEffect } from "react";
import { use } from "react";
import { formatDate } from "../config/Config";

const StaffDetails = ({ show, setShowStaffDetails, staffInfo }) => {
	return (
		<Dialog
			onHide={() => {
				setShowStaffDetails(false);
			}}
			style={{ width: "90vw", height: "90vh" }}
			header="Staff Details"
			modal
			visible={show}
			footer={
				<>
					<Button className="p-button-danger" type="button" label="Close" onClick={() => setShowStaffDetails(false)} />
				</>
			}
		>
			<Divider align="center">
				<h5 class="">Personal details</h5>
			</Divider>
			<div className="grid card mt-2 mx-1">
				<div class="col-12">
					<div class="row flex">
						<div class="text-left col-6 font-bold">First Name :</div>
						<div class="col-6 text-start"> {staffInfo.firstname}</div>
					</div>
					<div class="row flex">
						<div class="text-left col-6 font-bold">Surname :</div>
						<div class="col-6 text-start"> {staffInfo.surname}</div>
					</div>
					<div class="row flex">
						<div class="text-left col-6 font-bold">Identity Number :</div>
						<div class="col-6 text-start"> {staffInfo.idNumber}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Gender :</div>
						<div class="col-6 text-start">{staffInfo.genderName}</div>
					</div>
					<div class="row flex">
						<div class="text-left col-6 font-bold">Contact Number :</div>
						<div class="col-6 text-start">{staffInfo.contactNumber}</div>
					</div>
					<div class="row flex ">
						<div class="col-6 text-left font-bold">Address :</div>
						<div class="text-start col-6">{staffInfo.address}</div>
					</div>
					<div class="row flex">
						<div class="text-left col-6 font-bold">Email Address :</div>
						<div class="col-6 text-start">{staffInfo.emailAddress}</div>
					</div>
				</div>
			</div>
			<Divider align="center">
				<h5>Demarcation Details</h5>
			</Divider>
			<div className="grid card mt-2 mx-1">
				<div class="col-12">
					<div class="row flex">
						<div class="col-6 text-left font-bold">Demarcation Level Name :</div>
						<div class="col-6 text-start">{staffInfo.demarcationLevelName}</div>
					</div>
					<div class="row flex ">
						<div class="col-6 text-left font-bold">Demarcation Name :</div>
						<div class="col-6 text-start">{staffInfo.demarcationName}</div>
					</div>
				</div>
			</div>
			<Divider align="center">
				<h5>Appointment Details</h5>
			</Divider>
			<div className="grid card mt-2 mx-1">
				<div class="col-12">
					<div class="row flex">
						<div class="col-6 text-left font-bold">Staff ID :</div>
						<div class="col-6 text-start">{staffInfo.staffID}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Staff Number :</div>
						<div class="col-6 text-start">{staffInfo.staffNumber}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Registration Number :</div>
						<div class="col-6 text-start">{staffInfo.registrationNumber}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Staff Role :</div>
						<div class="col-6 text-start">{staffInfo.roleName}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Staff Type :</div>
						<div class="col-6 text-start">{staffInfo.staffTypeName}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Date Appointed :</div>
						<div class="col-6 text-start">{formatDate(staffInfo.dateAppointed)}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Status :</div>
						<div class="col-6 text-start">{staffInfo.active === true ? "Active" : "Not Active"}</div>
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default StaffDetails;
